<template>
	<AppModal
		modal-class="rounded-md min-w-[80vw]"
		:body-scroll="false"
		fill-screen
		@cancel="onCancel"
	>
		<AppDataGrid
			grid-name="grid"
			:resource-url="customResourceUrl || resource.uri"
			:resource-key="resource.name"
			:resource-name="resource.title"
			:grid-key="gridKey"
			:filters="filters"
			:on-row-selected="
        (e) => (selection = e.api.getSelectedRows().map((r) => r.id))
      "
			:row-class-rules="defineGridColors(resource.name)"
			:on-row-double-clicked="(e) => onConfirm(e.data.id)"
			:row-selection="selectionMode"
			@selected="(e) => (selectedRows = e.api.getSelectedRows())"
		>
			<template #toolbar>
				<span/>
			</template>
		</AppDataGrid>
		<template #footer>
			<div
				class="absolute bottom-20 right-12 flex flex-row gap-2 bg-gray-700 rounded-xl shadow-xl p-3"
			>
				<AppButton @click="onCancel">
					Annuleren
				</AppButton>
				<AppButton
					:disabled="selection.length == 0"
					@click="onConfirm(undefined)"
				>
					<p class="flex">
						Selectie bevestigen ({{ selection.length }}<span class="ml-0.5" v-if="showSelectedWeightSum">
              {{ selectedRows.length == 1 ? 'lot' : 'loten' }},
              {{ sum(selectedRows.map((row) => row.availableWeight)) }} kg,
              {{ sum(selectedRows.map((row) => row.availablePackageQuantity)) }} colli,
              {{ sum(selectedRows.map((row) => row.availableUnitQuantity)) }} eenheden
            </span>)
					</p>
				</AppButton>
			</div>
		</template>
	</AppModal>
</template>

<script setup lang="ts">
import { Resource } from "@q-food/q-food";
import { lotStatusColor } from "~utils/Grids/StatusColorRules.ts";
import { sum } from "@antfu/utils";

function defineGridColors(resourceName: string) {
	switch (resourceName) {
		case "lot":
			return lotStatusColor();
		default:
			return null;
	}
}

const selectedRows = ref<any[]>([]);

const props = withDefaults(
	defineProps<{
		resource: Resource;
		gridKey?: string;
		selectionMode?: "singleRow" | "multiRow";
		customResourceUrl?: string;
		filters?: string;
	}>(),
	{
		selectionMode: "singleRow",
	},
);

const showSelectedWeightSum = inject("gridLookup:showSelectedWeightSum");

const { customResourceUrl, resource } = toRefs(props);
const selection = ref<string[]>([]);

function onConfirm(value?: string) {
	if (typeof value === "string") {
		return emit("confirm", [value]);
	} else if (selection.value.length > 0) {
		return emit("confirm", selection.value);
	}
}

function onCancel() {
	selection.value = [];
	emit("cancel");
}

const emit = defineEmits<{
	(e: "confirm", value: string[]): void;
	(e: "cancel"): void;
}>();

const { escape, enter } = useMagicKeys();
whenever(escape, () => {
	onCancel();
});

whenever(enter, () => {
	onConfirm();
});
</script>

<style scoped></style>
